export { default } from './Register.data';
